import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Panel } from "@/components/Layout";
import { Switch } from "@/components/ui/switch";
import { api, formatError } from "@/lib/api";

export const AdminIdPolicy = () => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/id-policy").then((r) => setP(r.data)); }, []);
  if (!p) return null;
  const toggle = async (c, on) => {
    const next = on ? [...p.required_categories, c] : p.required_categories.filter((x) => x !== c);
    try {
      const { data } = await api.patch("/admin/id-policy", { required_categories: next });
      setP({ ...p, required_categories: data.required_categories });
      toast.success("ID policy saved");
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  return (
    <Panel title="Letters that always need an ID check" testId="admin-id-policy">
      <p className="text-sm text-slate-500 mb-4">Letters in these categories always require the recipient to verify their ID (£{p.surcharge_gbp.toFixed(2)} surcharge). Changes are recorded in the audit trail.</p>
      <div className="grid sm:grid-cols-3 gap-3">
        {p.categories.map((c) => (
          <label key={c} className="flex items-center gap-3 text-sm capitalize rounded-lg border border-slate-200 dark:border-slate-800 p-3">
            <Switch data-testid={`admin-id-category-${c}`} checked={p.required_categories.includes(c)} onCheckedChange={(v) => toggle(c, v)} /> {c}
          </label>
        ))}
      </div>
    </Panel>
  );
};

export const OrgIdPolicy = () => {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/id-policy").then((r) => setOn(r.data.org_all_letters)); }, []);
  if (on === null) return null;
  const change = async (v) => {
    try {
      setOn((await api.patch("/org/id-policy", { all_letters: v })).data.all_letters);
      toast.success(v ? "ID checks required on all letters" : "ID checks no longer required on all letters");
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  return (
    <label className="flex items-start gap-3 text-sm">
      <Switch data-testid="org-id-policy-switch" checked={on} onCheckedChange={change} />
      <span>Require recipients to verify their ID for every letter this organisation sends (£1.50 per letter). Only the result is kept, never ID images.</span>
    </label>
  );
};
